export default __webpack_public_path__ + "static/media/8.00f6c891.webp";